import { WebParameterContext, WebResponesContext } from '../../model/common';
import { DatePipe } from '@angular/common';
export class ServicesPGUnBindStore {
    constructor(
    ) {

    }
    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        webcontext.OpType = "edite";
        let request = JSON.parse(webcontext.RequestBody);
        let datepie: DatePipe = new DatePipe("en-US");
        let id = localStorage.getItem("PgUnBindStroeId");
        if (id){
            request["a_ID"] = id;//
        }
        if(request["a_LeaveDate"]){
            request["a_LeaveDate"] = request["a_LeaveDate"].replace("T"," ").replace("Z","").replace("-00:00","");
        }
        let _arr = [request];
        // console.log(request);
        // webcontext.ResponseMessage.ErrorMessage ="结束时间不能为空";
        // webcontext.ResponseMessage.Success = false;
        webcontext.RequestBody = JSON.stringify(_arr);
        

        return webcontext;
    }
    public HandleServerContextAfterDBRequest(webParameterContext: WebParameterContext, webContext: WebResponesContext): WebResponesContext {
        const that = this;
        if (webParameterContext.ConfigType.toLowerCase() == "form") {
            // if (webContext.ResponseMessage.Success) {
            //     if (webContext.Other) {
            //         webContext.Other.Success = true;
            //         webContext.url = "/login";
            //     } else {
            //         webContext.Other = { "Success": true, "url": "/login" };
            //     }
            // }

            // webContext.ResponseMessage.ErrorMessage="排版成功,请尽快联系上级领导审批通过后方可进入此系统";
            // webContext.ResponseMessage.Success=false;
        }
        return webContext
    }
}